import { inject, Injectable } from '@angular/core';
import { IVehicle, UUID } from '@okcargo-apps/shared-domain';
import { VehicleCommandService } from '@okcargo-apps/shared-infrastructure';

@Injectable({
  providedIn: 'root',
})
export class VehiclesMutationsService {
  private readonly vehicleCommandService = inject(VehicleCommandService);

  public createVehicle(vehicle: IVehicle): Promise<void> {
    return this.vehicleCommandService.createVehicle(vehicle);
  }

  public updateVehicle(vehicle: IVehicle): Promise<void> {
    return this.vehicleCommandService.updateVehicle(vehicle);
  }

  public softDeleteVehicle(id: UUID): Promise<void> {
    return this.vehicleCommandService.softDeleteVehicle(id);
  }
}
